import { Action, createReducer, on } from '@ngrx/store';
import { LoyaltyWebsiteState } from './loyalty-website.state';
import {
  openWebsiteSuccessAction,
  openWebsitePageErrorAction,
  openPublicWebsitePageAction,
  openClickeAndCollectWebsiteAction,
  pageOpenedAction,
  openWebsitePageAction,
} from './loyalty-website.actions';
import { WebsitePageNamesEnum } from '../enums';

const initialState = new LoyaltyWebsiteState();

const reducer = createReducer(
  initialState,
  on(openWebsiteSuccessAction, (state, payload) => {
    const newState = { ...state };
    newState.currentPage = payload.pageName;
    newState.isLoading = false;
    return newState;
  }),
  on(openWebsitePageErrorAction, (state, payload) => {
    const newState = { ...state };
    newState.currentPage = null;
    newState.isLoading = false;
    newState.failures = payload.failure;
    return newState;
  }),
  on(openPublicWebsitePageAction, (state, payload) => {
    const newState = { ...state };
    newState.currentPage = payload.pageName;
    newState.isLoading = true;
    return newState;
  }),
  on(openWebsitePageAction, (state, payload) => {
    const newState = { ...state };
    newState.currentPage = payload.pageName;
    newState.isLoading = true;
    return newState;
  }),
  on(openClickeAndCollectWebsiteAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = true;
    newState.currentPage = WebsitePageNamesEnum.ClickAndCollect_Sites;
    return newState;
  }),
  on(pageOpenedAction, (state) => {
    const newState = { ...state };
    newState.isLoading = false;
    return newState;
  })
);

export function loyaltyWebsiteReducer(state: LoyaltyWebsiteState | null, action: Action) {
  return reducer(state, action);
}
